import React from "react";
import { Box } from "@material-ui/core";
// Local
import companyLogo from "../assets/img/logo.png";
import { CopyrightText, VersionText } from "../components";
import { useStyles } from "./AuthAreaLayout.styles";

function _AuthAreaLayout(props) {
  const classes = useStyles();
  const { children } = props;
  return (
    <div className={classes.desktopContainer}>
      {/* Left navy sidebar — desktop only */}
      <Box className={classes.desktopSidebar}>
        <div className={classes.sidebarLogoWrap}>
          <img src={companyLogo} alt="Company Logo" />
        </div>
      </Box>

      {/* Right side: canvas on desktop, navy on mobile */}
      <div className={classes.baseContainer}>
        {/* Logo visible only on mobile */}
        <Box className={classes.logoBox}>
          <img src={companyLogo} alt="Company logo" />
        </Box>

        {/* White card on desktop, plain on mobile */}
        <div className={classes.card}>
          {children}
        </div>

        <Box className={classes.footerBox}>
          <VersionText /> <CopyrightText />
        </Box>
      </div>
    </div>
  );
}

export const AuthAreaLayout = React.memo(_AuthAreaLayout);